module.exports = __webpack_public_path__ + "static/media/SSO_Background_Image.fb1e2381.jpg";